import React, { useState } from "react";
import { Menu } from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import BannerList from "./components/BannerList";
import HotList from "./components/HotList";
export default function HotManage() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "hotReviewing";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "热榜",
      key: "hotReviewing",
    },
    {
      label: "banner",
      key: "bannerReviewing",
    },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
    window.location.reload();
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[pathname]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/hotManage/hotReviewing" />} />
        <Route
          path="/hotReviewing"
          element={<HotList current="hotReviewing" />}
        />
        <Route
          path="/bannerReviewing"
          element={<BannerList current="bannerReviewing" />}
        />
      </Routes>
    </div>
  );
}
